













import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {DynamicDocumentUtils} from '@/views/dynamicdocuments/dynamic-document.utils';

import '@/compiled-icons/add';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import DynamicDocumentTextFieldTemplate from '../fields/dynamic-document-text-field-template.vue';
import DynamicDocumentScreenWidthConfigurationTemplate from '../fields/dynamic-document-screen-width-configuration-template.vue';

@Component({
  name: 'dynamic-document-text-brick-template',
  components: {
    DynamicDocumentScreenWidthConfigurationTemplate,
    DynamicDocumentTextFieldTemplate
  }
})
export default class DynamicDocumentTextBrickTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldDtoV2 | undefined;
  @Prop({required: true}) context: DisguiseDto.DynamicDocumentContextDto | undefined;

  sizes = DynamicDocumentUtils.SIZE_SELECTOR;
  replacementToken: DisguiseDto.DynamicDocumentReplacementTokenDto[] = [];

  created() {
    HTTP_SERVICE_INSTANCE.getAxios().get<DisguiseDto.DynamicDocumentReplacementTokenDto[]>(
        `/dynamicdocuments/v1/documents/contexttypes/${this.context}/replacementtoken/text`
    ).then((response) => {
      this.replacementToken = response.data;
    });
  }
}
